import * as React from 'react';
import styled from 'styled-components';
import Dialog from 'material-ui/Dialog';

import { constants } from '../../constants';

const StyledDialog = styled(Dialog)`
    div > div > div > div {
        max-height: 4000px !important;
    }
        overflow: scroll;

` 

const ScrollBodyDialog = ({style, children, ...rest }) => (
    <StyledDialog style={style} {...rest}>
            {children}
    </StyledDialog>
);

export default ScrollBodyDialog;





// WEBPACK FOOTER //
// ./src/js/components/Dialog/ScrollBodyDialog.jsx